<template>
  <div class="introduction-container">
    <div class="breadcrumbs mb-40">
      <breadcrumb path="/documentation/developer-guide" name="Homepage" :routeName="route.name" />
    </div>
    <section class="overall-procedure mb-40">
      <div class="title font-20">
        {{ $t('developer_guide.overall_procedure') }}
      </div>
      <div class="submenu-container">
        <img :src="path_assets + '/overall-procedure.png'" class="mr-12" />
      </div>
    </section>
    <section class="step-1 mb-40">
      <div class="title font-20">
        {{ $t('developer_guide.step1.title') }}
      </div>
      <div class="submenu-container">
        <div class="font-14 mt-40">
          {{ $t('developer_guide.step1.step1_a') }}
        </div>
        <img :src="path_assets + '/01-register.png'" />
      </div>
      <div class="submenu-container">
        <div class="font-14 mt-40">
          {{ $t('developer_guide.step1.step1_b') }}
        </div>
        <img :src="path_assets + '/02-verification.png'" />
      </div>
      <div class="submenu-container">
        <div class="font-14 mt-40">
          {{ $t('developer_guide.step1.step1_c') }}
        </div>
        <img :src="path_assets + '/03-verification-email.png'" />
      </div>
      <div class="submenu-container">
        <div class="font-14 mt-40">
          {{ $t('developer_guide.step1.step1_d') }}
        </div>
        <img :src="path_assets + '/03-verified.png'" />
      </div>
      <div class="submenu-container">
        <div class="font-14 mt-40">
          {{ $t('developer_guide.step1.step1_e') }}
        </div>
        <img :src="path_assets + '/03-verified-email.png'" />
      </div>
      <div class="submenu-container">
        <div class="font-14 mt-40">
          {{ $t('developer_guide.step1.step1_f') }}
        </div>
        <img :src="path_assets + '/04-login.png'" />
      </div>
      <div class="submenu-container">
        <div class="font-14 mt-40">
          {{ $t('developer_guide.step1.step1_g') }}
        </div>
        <img :src="path_assets + '/04-forgot-password.png'" />
      </div>
      <div class="submenu-container">
        <div class="font-14 mt-40">
          {{ $t('developer_guide.step1.step1_h') }}
        </div>
        <img :src="path_assets + '/04-reset-password-email.png'" />
      </div>
      <div class="submenu-container">
        <div class="font-14 mt-40">
          {{ $t('developer_guide.step1.step1_i') }}
        </div>
        <img :src="path_assets + '/04-reset-password.png'" />
      </div>
    </section>
    <section class="step-2 mb-40">
      <div class="title font-20">
        {{ $t('developer_guide.step2.title') }}
      </div>
      <div class="submenu-container">
        <div class="font-14">
          {{ $t('developer_guide.step2.step2_a') }}
        </div>
        <img :src="path_assets + '/05-login-olsera.png'" />
      </div>
      <div class="submenu-container">
        <div class="font-14 mt-40">
          {{ $t('developer_guide.step2.step2_b') }}
        </div>
        <img :src="path_assets + '/06-form-login-olsera.png'" />
      </div>
      <div class="submenu-container">
        <div class="font-14 mt-40">
          {{ $t('developer_guide.step2.step2_c') }}
        </div>
        <img :src="path_assets + '/07-store-list.png'" />
      </div>
      <div class="submenu-container">
        <div class="font-14 mt-40">
          {{ $t('developer_guide.step2.step2_d') }}
        </div>
        <img :src="path_assets + '/08-store-list-select.png'" />
      </div>
      <div class="submenu-container">
        <div class="font-14 mt-40">
          {{ $t('developer_guide.step2.step2_e') }}
        </div>
        <img :src="path_assets + '/09-create-pairing-store.png'" />
      </div>
      <div class="submenu-container">
        <div class="font-14 mt-40">
          {{ $t('developer_guide.step2.step2_f') }}
        </div>
        <img :src="path_assets + '/10-list-pairing-store.png'" />
      </div>
      <div class="submenu-container">
        <div class="font-14 mt-40">
          {{ $t('developer_guide.step2.step2_g') }}
        </div>
        <img :src="path_assets + '/11-detail-pairing-store.png'" />
      </div>
      <div class="submenu-container">
        <div class="font-14 mt-40">
          {{ $t('developer_guide.step2.step2_h') }}
        </div>
        <img :src="path_assets + '/12-get-token-collection.png'" />
      </div>
      <div class="submenu-container">
        <div class="font-14 mt-40">
          {{ $t('developer_guide.step2.step2_i') }}
        </div>
        <img :src="path_assets + '/13-testools-direct.png'" />
      </div>
      <div class="submenu-container">
        <div class="font-14 mt-40">
          {{ $t('developer_guide.step2.step2_j') }}
        </div>
        <img :src="path_assets + '/14-testools-send.png'" />
      </div>
      <div class="submenu-container">
        <div class="font-14 mt-40">
          {{ $t('developer_guide.step2.step2_k') }}
        </div>
        <img :src="path_assets + '/16-edit-pairing-store.png'" />
      </div>
      <div class="submenu-container">
        <div class="font-14 mt-40">
          {{ $t('developer_guide.step2.step2_l') }}
        </div>
        <img :src="path_assets + '/16-delete-pairing-store.png'" />
      </div>
    </section>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import Breadcrumb from '@/components/layout/Breadcrumb.vue'

const store = useStore()
const route = useRoute()
const path_assets = computed(() => {
  if (store.getters['app/lang'] === 'id') {
    return '/img/assets/developer-guide/id'
  } else {
    return '/img/assets/developer-guide/en'
  }
})
</script>

<style lang="scss" scoped>
.submenu-container {
  max-width: 75%;
  & img {
    max-width: 806px;
  }
}
</style>
